import { getUserDetails } from 'modules/platform-components/utils/shared-data.service';
import {
  getInstutueApp,
  postInstituteAppData,
  putInstituteAppData,
  deleteInstituteAppData,
  apiPaths,
} from 'modules/platform-components/api-integration-util';

const getHeaders = () => {
  const user = getUserDetails();
  return { tenantId: user.tenantId, userEmail: user.email };
};

// ─── Fetch ────────────────────────────────────────────────────────────────

export const fetchAllPrompts = () =>
  getInstutueApp(apiPaths.llmPromptsAll, {}, getHeaders());

export const fetchPromptStats = () =>
  getInstutueApp(apiPaths.llmPromptsStats, {}, getHeaders());

export const searchPrompts = (searchTerm) =>
  getInstutueApp(apiPaths.llmPromptsSearch, { searchTerm }, getHeaders());

export const fetchPromptVersions = (promptKey) =>
  getInstutueApp(`${apiPaths.llmPromptsVersions}/${promptKey}`, {}, getHeaders());

export const fetchDistinctUseCases = () =>
  getInstutueApp(apiPaths.llmPromptsDistinctUseCases, {}, getHeaders());

export const fetchDistinctPromptTypes = () =>
  getInstutueApp(apiPaths.llmPromptsDistinctPromptTypes, {}, getHeaders());

export const fetchDistinctDifficulty = () =>
  getInstutueApp(apiPaths.llmPromptsDistinctDifficulty, {}, getHeaders());

export const fetchPromptsByUseCase = (useCase) =>
  getInstutueApp(`${apiPaths.llmPromptsByUseCase}/${useCase}`, {}, getHeaders());

export const fetchPromptsByType = (promptType) =>
  getInstutueApp(`${apiPaths.llmPromptsByType}/${promptType}`, {}, getHeaders());

export const fetchPromptsByDifficulty = (level) =>
  getInstutueApp(`${apiPaths.llmPromptsByDifficulty}/${level}`, {}, getHeaders());

export const fetchPromptKeys = () =>
  getInstutueApp(apiPaths.llmPromptsKeys, {}, getHeaders());

// ─── Mutate ───────────────────────────────────────────────────────────────

export const createPrompt = (data) =>
  postInstituteAppData(apiPaths.llmPromptsCreate, { data, headers: getHeaders() });

export const updatePrompt = (promptId, data) =>
  putInstituteAppData(`${apiPaths.llmPromptsUpdate}/${promptId}`, { data, headers: getHeaders() });

export const deletePrompt = (promptId) =>
  deleteInstituteAppData(`${apiPaths.llmPromptsDelete}/${promptId}`, { headers: getHeaders() });

export const createNewVersion = (promptKey, data) =>
  postInstituteAppData(`${apiPaths.llmPromptsCreateVersion}/${promptKey}`, { data, headers: getHeaders() });

export const deactivateVersion = (promptKey, version) =>
  putInstituteAppData(`${apiPaths.llmPromptsDeactivate}/${promptKey}/version/${version}`, { headers: getHeaders() });

// ─── Validation & Templates ──────────────────────────────────────────────

export const validatePromptContent = (content) =>
  postInstituteAppData(apiPaths.llmPromptsValidate, { data: { content }, headers: getHeaders() });

export const processTemplate = (templateContent, variables) =>
  postInstituteAppData(apiPaths.llmPromptsProcessTemplate, { data: { templateContent, variables }, headers: getHeaders() });
